
import React, { Component}  from 'react';

import { FormContext } from 'core/FormProvider';
import { ContextFormControlWidget, ContextWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import { AsyncSelectWidget } from 'form/SelectAsync';
import { SelectWidget } from "form/Select";
import FormGroup from 'form/FormGroup';
import CarrierForm from "./Forms/CarrierForm";
import {CheckboxWidget} from "form/Checkbox";


export class ChoiceForm extends Component {

  handleChangeType = (context, value) => {
    console.log(context, value);
    context.setValue('type', value);
  }

  render() {
    return (
      <FormContext.Consumer>
        {context => {
          const { item } = context;
          return (
            <FormGroup>
              <ContextFormControlWidget
                name={'type'}
                label={'Тип справочника'}
                WidgetComponent={AsyncSelectWidget}
                widgetProps={{
                  url: 'catalog/choice/types',
                  label: 'Тип справочника',
                  optionLabel: 'label',
                  optionValue: 'value',
                  disabled: item.id !== undefined,
                  onChange: (value) => this.handleChangeType(context, value)
                }}
              />

              <ContextWidget
                name={'name'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Значение',
                  required: true
                }}
              />

              <div className={'mb-20'}>
                <ContextWidget
                  name={'is_active'}
                  WidgetComponent={CheckboxWidget}
                  widgetProps={{
                    label: 'Активность'
                  }}
                />
              </div>

              {item.type === 'CONTAINER_TYPE' && (
                <ContextFormControlWidget
                  name={'size'}
                  label={'Размер'}
                  WidgetComponent={SelectWidget}
                  widgetProps={{
                    label: 'Размер',
                    options: [
                      {label: '20\'', value: '20'},
                      {label: '40\'', value: '40'},
                    ]
                  }}
                />
              )}

              <ContextWidget
                name={'description'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Описание'
                }}
              />

              {['SHIPPER', 'CONSIGNEE'].includes(item.type) && (
                <ContextWidget
                  name={'data.inn'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'ИНН'
                  }}
                />
              )}

              {item.type === 'CARRIER' && (
                <CarrierForm />
              )}

            </FormGroup>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
